import { useContext } from 'react';
import { VirtualSlotsPlaceholderHostId } from '../slotsPlaceholderContext';
import { buildUniqueSlotId } from '../utils/buildUniqueSlotId';
export const useSlotUniqueId = (slotId) => {
    const hostCompId = useContext(VirtualSlotsPlaceholderHostId);
    return buildUniqueSlotId(hostCompId, slotId);
};
//# sourceMappingURL=useSlotUniqueId.js.map